module.exports = __webpack_public_path__ + "media/images/reporting-paradigm-background-a4c688ca9665776ec13aa6d5def71a8e.png";